export default __webpack_public_path__ + "static/media/star.4a24df34.svg";